import { map } from '@skinsoft/data-store';
import { EntityDataStore } from '@skinsoft/entity-data-store';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Observable } from 'rxjs';
import { Component, Watch } from 'vue-property-decorator';
import Router from 'vue-router';

import { Featured } from '../featured-card';
import { FeaturedList } from '../featured-list';

const FEATURED_ITEM_COUNT = 3;

@Component({
    components: {
        sFeaturedList: FeaturedList,
    },
    props: ['entityDataStore', 'featuredStates', 'sortFields', 'serializer', 'targetRouteName'],
    template: require('./entity-featured-list.html'),
})
export class EntityFeaturedList<T extends { id: string }> extends ReactiveVue {
    public entityDataStore: EntityDataStore<T>;
    public featuredStates: string[];
    public sortFields: string[];
    public targetRouteName: string;

    public featureds: Array<Featured | null> = Array(FEATURED_ITEM_COUNT).fill(null);
    public serializer: (entity: T) => Observable<Featured>;
    public $router: Router;

    public created() {
        this.subscribe();
    }

    public onFeaturedClik([featured]: [Featured]) {
        if (!featured) {
            // still loading
            return;
        }

        const index = this.featureds.findIndex(i => (i as Featured).id === featured.id);
        const next = this.featureds.filter((_, k) => k > index).map(v => (v as Featured).id);
        const query: Record<string, string> = next ? { next: next as any } : {};

        const params: Record<string, string> = { id: featured.id };

        return this.$router.push({ name: this.targetRouteName, params, query });
    }

    private subscribe() {
        this.subscribeTo(
            this.entityDataStore
                .fetchAll({
                    query: {
                        ...(this.featuredStates.length > 0 && {
                            states: this.featuredStates.join(','),
                        }),
                        sortAsc: 'true',
                        ...(this.sortFields.length > 0 && {
                            sortFields: this.sortFields.join(','),
                        }),
                    },
                    userScope: true,
                })
                .pipe(map(this.serializer)),
            (featureds: Featured[]) => {
                this.featureds = featureds;
                (this.featureds as Featured[]).sort((a: Featured, b: Featured) => {
                    const aIndex = this.featuredStates.indexOf(a.state);
                    const bIndex = this.featuredStates.indexOf(b.state);

                    if (aIndex > bIndex) {
                        return 1;
                    }

                    if (aIndex === bIndex) {
                        return 0;
                    }

                    return -1;
                });
            },
            'featureds',
        );
    }

    private unsubscribe() {
        this.unsubscribeFrom('featureds');
    }

    @Watch('entityDataStore')
    private onEntityDataStoreChange() {
        this.unsubscribe();
        this.subscribe();
    }
}
